import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { TooltipContext } from "@cargo/common";

import './button.scss';
import { FRONTEND_DATA } from '../../../apps/admin/src/globals';

export class Button extends Component {

	constructor(props) {
		super(props);
		this.buttonRef = React.createRef();
	}

	componentDidMount() {
		const globalDragEventController = FRONTEND_DATA?.globals?.ADMIN_FRAME?.globalDragEventController;
		if ( globalDragEventController && this.props.onDragOver) {
			globalDragEventController.on('dragover', this.props.onDragOver);
		}
		if ( globalDragEventController && this.props.onDragEnter) {
			globalDragEventController.on('dragenter', this.props.onDragEnter);
		}
		if ( globalDragEventController && this.props.onDragLeave) {
			globalDragEventController.on('dragleave', this.props.onDragLeave);
		}
		if ( globalDragEventController && this.props.onDrop) {
			globalDragEventController.on('drop', this.props.onDrop);
		}
	}

	componentWillUnmount() {
		const globalDragEventController = FRONTEND_DATA?.globals?.ADMIN_FRAME?.globalDragEventController;
		if ( globalDragEventController && this.props.onDragOver) {
			globalDragEventController.off('dragover', this.props.onDragOver);
		}
		if ( globalDragEventController && this.props.onDragEnter) {
			globalDragEventController.off('dragenter', this.props.onDragEnter);
		}
		if ( globalDragEventController && this.props.onDragLeave) {
			globalDragEventController.off('dragleave', this.props.onDragLeave);
		}
		if ( globalDragEventController && this.props.onDrop) {
			globalDragEventController.off('drop', this.props.onDrop);
		}
	}

	render() {

		const {
			label,
			labelHtml, 
			icon, 
			title, 
			innerPadding, 
			className, 
			toolTipIcon, 
			innerRef, 
			children, 
			iconLabel, 
			uiWindowIsOpen, 
			onDrop,
			onDragOver,
			onDragEnter,
			onDragLeave,
			onMouseDown, 
			onPointerEnter, 
			onPointerLeave,
			tooltipOffsetX,
			tooltipOffsetY,
			...otherProps
		} = this.props;

		return (
			<TooltipContext.Consumer>
			    {(Tooltip) => 
					<button
						{...otherProps}
						className={`${ this.props.className ? this.props.className : ''}${iconLabel ? ' icon-first' : ''}`}
						title={title}
						ref={this.buttonRef}
						onPointerEnter={(e) => {

							if (onPointerEnter) {
								onPointerEnter(e)
							}

							if( !this.props.tooltip ){ return }
							if( uiWindowIsOpen ){ return }

							let buttonPos = this.buttonRef.current.getBoundingClientRect();

							Tooltip.openTip?.({
							    innerText: this.props.tooltip,
							    shortcutText: null,
							    icon: toolTipIcon,
							    buttonPos: {
							    	x: buttonPos.x,
							    	y: buttonPos.y,
							    	width: buttonPos.width,
							    	height: buttonPos.height,
							    	customOffsetX: this.props.tooltipOffsetX,
							    	customOffsetY: this.props.tooltipOffsetY
							    },
							    event: e,
							})
							
						}}
						onPointerLeave={(e) => { 

							if (onPointerLeave) {
								onPointerLeave(e)
							}

							if( !this.props.tooltip ){ return } 
							Tooltip.closeTip?.(e) 

		
						}}
						onMouseDown={(e) => { 

							if (this.props.tooltip) {
								Tooltip.closeTip?.(e)
							}

							if (this.props.type === 'link') {
								// open URL in new tab
								if (e.metaKey === true || e.ctrlKey === true ) {
									window.open(this.props.href, '_blank');
								// open URL in same window
								} else {
									window.location.href = this.props.href
								}
							}

							// run the button's original pointerDown method
							if (onMouseDown) {
								onMouseDown(e)
							}

						}}
						type={ this.props.type ? ( this.props.type ) : ( "button" )}
					>
						<>
							{iconLabel ? ( 
								<>
									{icon}
									{label ?? (labelHtml && <span dangerouslySetInnerHTML={{__html: labelHtml}}></span>)}
								</>
							) : ( 
								<>
									{label ?? (labelHtml && <span dangerouslySetInnerHTML={{__html: labelHtml}}></span>)}
									{icon}
								</>
							)}
							{children}
						</>
					</button>
				}
			</TooltipContext.Consumer>
		);

	}

};